// extracted by mini-css-extract-plugin
export default {"body":"PageContainer_body__+yX-x","content":"PageContainer_content__JbxoL","mainDrawerOpen":"PageContainer_mainDrawerOpen__jqnrv"};